import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";

export const NewsletterAPI = async (params) => {
  const url = `${BaseUrl}/InsertNewsLetter`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
export const ContactUSApi = async (params) => {
  const url = `${BaseUrl}/ContactUS`;
  const res = await postApiWithoutAuthorization(url, params);
  return res;
};
